import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import LazyLoad from 'react-lazyload';

import { useGlobalContext } from '../../AppContext';
import { Loading } from '../Loading';

import './NFT.scss';

interface NFTProps {
  name: string;
  network: string;
  id: string;
  image: string;
  contract: string;
  n: string;
  price?: string;
  wallet?: string;
}
// https://api.opensea.io/api/v1/asset_contract/0xbc8542e65ab801f7c9e3edd23238d37a2e3972d6
export function NFT(props: NFTProps) {
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    const handleThemeChange = () => {
      const newTheme = document.body.classList.contains('light') ? 'light' : 'dark';
      setTheme(newTheme);
    };

    handleThemeChange();

    const observer = new MutationObserver(handleThemeChange);
    const config = { attributes: true, attributeFilter: ['class'] };
    observer.observe(document.body, config);

    return () => {
      observer.disconnect();
    };
  }, []);

  const { customSearch } = useGlobalContext();
  const [, setLoaded] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoaded(true);
    setLoading(false);
    //if (!loaded) fetchDetails();
  }, [props]);

  return (
    <div className={`nft-${theme}`} title={`${props.name}${props.network}${props.id}${props.contract}`}>
      <div className="image-container">
      <LazyLoad once>
        <img src={props.image} alt="" />
      </LazyLoad>
      </div>
      <div className="nft-details">
        <div className="name">
          <div className="collection">{props.name}</div>
          <div className="tokenid">#{props.id}</div>
        </div>
        <div className="contract">
          <Link
            target="_blank"
            to={{
              pathname: `https://opensea.io/assets?search[query]=${props.contract}`,
            }}
          >
            {props.contract!.substr(0, 14)}...{props.contract!.substr(-14, 14)}
          </Link>
        </div>
        <div className="network">
          <img
            className="nft-network-icon"
            src={
              props.n === 'ethereum'
                ? '/icons/networks/erc20.png'
                : props.n === 'matic'
                ? '/icons/networks/polygon.png'
                : props.n === 'avalanche'
                ? '/icons/networks/avalanche.png'
                : '/icons/networks/bep20.png'
            }
            alt=""
          />{' '}
          {props.wallet}
          {props.price && (
            <div className="price">
              <strong>
                {props.price}{' '}
                {props.n === 'ethereum'
                  ? 'ETH'
                  : props.n === 'matic'
                  ? 'MATIC'
                  : props.n === 'avalanche'
                  ? 'AVAX'
                  : 'BNB'}
              </strong>
            </div>
          )}
        </div>

        {loading ? (
          <Loading inline={true} />
        ) : (
          <div className="nft-button mt-4 text-color-black">
            <Link
              target="_blank"
              to={{
                pathname: `https://opensea.io/assets/${props.n}/${props.contract}/${props.id}`,
              }}
            >
              {customSearch ? 'Buy Now' : 'See Details'}
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
